const CATCH_CONFIG = 'CATCH_CONFIG';
const CHECK_HOST = 'CHECK_HOST';
const REFRESH_IMG = 'REFRESH_IMG';
const SHOW_IDENTIFY = 'SHOW_IDENTIFY';
const SAVE_USER = 'SAVE_USER';

const Base = {
	state: {
		config: {
			header: '',
			footer: '',
			share: '',
			bg_color: '',
			title_color: '',
			button_color: '',
			progress_color: '',
			title: '',
			share_desc: '',
			start_time: '',
			end_time: ''
		},
		Host: '',
		identifyStatus: {
			status: false,
			mock_height: '100%'
		},
		identify: {
			url: '',
			key: '',
			refresh_url: ''
		},
		user:{
			userId: '',
			status: false
		}
	},
	
	mutations: {
		[CATCH_CONFIG]: (state, payload) => {
			state.config = payload;
		},
		[CHECK_HOST]: (state, payload) => {
			state.Host = payload;
		},
		[REFRESH_IMG]: (state, payload) => {
			state.identify = payload;
		},
		[SHOW_IDENTIFY]: (state, payload) => {
			state.identifyStatus = payload;
		},
		[SAVE_USER]: (state, payload) => {
			state.user = payload;
		}
	},

	getters: {

	},
	
	actions: {
		catchConfig(context, payload) {
			context.commit(CATCH_CONFIG, payload);
		},
		checkHost(context, payload) {
			payload = payload == 'development'? '': '';
			context.commit(CHECK_HOST, payload);
		},
		refreshImg(context, payload) {
			context.commit(REFRESH_IMG, payload);
		},
		showIdentify(context, payload) {
			context.commit(SHOW_IDENTIFY, payload);
		},
		saveUser(context, payload) {
			context.commit(SAVE_USER, payload);
		}
	}
};

export default Base;


// WEBPACK FOOTER //
// ./src/store/base.js